// import Icon from '@/components/ui/icon/Icon';
import './style.scss'

function FiledCheckbox(props) {
    const { value, defaultValue, icon = '', tumbler, text, checked, onChange, ...rest } = props

    const { type } = props
    const isControlled = checked !== undefined

    const computedClass = () => {
        const classes = {
            'field-checkbox--radio': type === 'radio' && !tumbler,
            'field-checkbox--tumbler': tumbler,
            // 'field-checkbox--inverted': this.field.inverted,
        }
        const prop = Object.entries(classes).find(([_, value]) => value)
        return (prop && prop[0]) || ''
    }

    return (
        <label className={`field-checkbox  ${computedClass()}`}>
            <input
                {...rest}
                type="checkbox"
                className="field-checkbox__input"
                {...(isControlled && { checked, onChange })}
            />
            <span className="field-checkbox__visual">
                {/* {!tumbler &&  <Icon className="field-checkbox__visual-icon" name="check"></Icon>} */}
            </span>
            <span className="field-checkbox__text" dangerouslySetInnerHTML={{__html:text}}></span>
        </label>
    )
}

export default FiledCheckbox
